/**
 * PostHog site-wide Shopify hooks — cart, variants, checkout, search, navigation.
 */
(function () {
  'use strict';

  function wph() {
    return window.whiskyPosthog;
  }

  function capture(event, properties) {
    var w = wph();
    if (w) {
      w.capture(event, properties);
      return;
    }
    if (typeof window.posthog !== 'undefined' && window.posthog.capture) {
      window.posthog.capture(event, properties || {});
    }
  }

  // A single add reaches this file twice: the theme's cartUpdate pubsub event
  // and the Concept theme's ajaxProduct:added DOM event both fire for it, so
  // product_added_to_cart has been double-counted since the PostHog hooks
  // landed. Measured 2026-08-28 over Aug 18-24: 956 duplicate pairs, pubsub
  // first in every single one (max gap 46ms), so dropping the repeat keeps the
  // richer pubsub event and leaves the ajax listener working as a fallback
  // where pubsub does not fire. Same rule and window the Klaviyo snippet
  // already uses (snippets/klaviyo-mystery-box-tracking.liquid).
  var lastAtcVariantId = null;
  var lastAtcTime = 0;

  function captureAddedToCart(variantId, properties) {
    var key = String(variantId || '');
    var now = new Date().getTime();
    if (key && key === lastAtcVariantId && now - lastAtcTime < 2000) return;
    lastAtcVariantId = key;
    lastAtcTime = now;
    capture('product_added_to_cart', properties);
  }

  function waitFor(condition, callback, attempts) {
    var max = attempts || 50;
    var i = 0;
    var timer = setInterval(function () {
      i += 1;
      if (condition()) {
        clearInterval(timer);
        callback();
      } else if (i >= max) {
        clearInterval(timer);
      }
    }, 100);
  }

  function bindThemePubsub() {
    if (!window.theme || !window.theme.pubsub) return;

    var events = window.theme.pubsub.PUB_SUB_EVENTS;

    window.theme.pubsub.subscribe(events.cartUpdate, function (payload) {
      if (!payload || !payload.cart) return;

      var cart = payload.cart;
      var props = {
        source: payload.source || 'unknown',
        variant_id: payload.productVariantId || null,
        cart_total: typeof cart.total_price === 'number' ? cart.total_price / 100 : null,
        cart_item_count: cart.item_count,
        currency: cart.currency || null
      };

      // The suppressed ajaxProduct duplicate used to be the only event carrying
      // product_title; the cart the pubsub payload hands over already names the
      // line, so keep that field on the surviving event. Quantity is left off
      // deliberately: the cart line holds the cumulative quantity in cart, not
      // the quantity just added, and a wrong number is worse than none.
      if (payload.productVariantId != null && Array.isArray(cart.items)) {
        for (var li = 0; li < cart.items.length; li++) {
          var line = cart.items[li];
          if (line && String(line.variant_id) === String(payload.productVariantId)) {
            if (line.product_title) props.product_title = line.product_title;
            break;
          }
        }
      }

      var w = wph();
      if (w) props = w.funnelContext(props);

      if (
        payload.source === 'product-form' ||
        payload.source === 'product-bundle' ||
        payload.source === 'dragon-slayer-explorer' ||
        (payload.source && String(payload.source).indexOf('father') !== -1)
      ) {
        captureAddedToCart(props.variant_id, props);
      } else {
        capture('cart_updated', props);
      }
    });

    window.theme.pubsub.subscribe(events.cartError, function (payload) {
      capture('cart_error', {
        source: payload && payload.source,
        variant_id: payload && payload.productVariantId,
        message: payload && payload.message
      });
    });

    window.theme.pubsub.subscribe(events.variantChange, function (payload) {
      if (!payload || !payload.data) return;
      var variant = payload.data.variant;
      if (!variant) return;

      capture('product_variant_selected', {
        product_id: payload.data.product && payload.data.product.id,
        variant_id: variant.id,
        variant_title: variant.title,
        price: typeof variant.price === 'number' ? variant.price / 100 : null,
        available: variant.available
      });
    });

    window.theme.pubsub.subscribe(events.facetUpdate, function (payload) {
      capture('collection_filtered', {
        source: payload && payload.source
      });
    });
  }

  function bindNavigation() {
    var lastPath = window.location.pathname;

    function onPathChange() {
      var path = window.location.pathname;
      if (path === lastPath) return;
      lastPath = path;
      capture('spa_navigation', {
        pathname: path,
        search: window.location.search
      });
    }

    window.addEventListener('popstate', onPathChange);
    var pushState = history.pushState;
    var replaceState = history.replaceState;
    if (pushState) {
      history.pushState = function () {
        pushState.apply(history, arguments);
        onPathChange();
      };
    }
    if (replaceState) {
      history.replaceState = function () {
        replaceState.apply(history, arguments);
        onPathChange();
      };
    }
  }

  document.addEventListener('ajaxProduct:added', function (event) {
    var detail = event.detail || {};
    var product = detail.product;
    if (!product) return;

    var ajaxVariantId = product.variant_id || product.id;
    captureAddedToCart(ajaxVariantId, {
      source: 'ajaxProduct',
      variant_id: ajaxVariantId,
      product_title: product.title,
      quantity: product.quantity
    });
  });

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest
      ? event.target.closest(
          '[href*="/checkout"], [name="checkout"], .cart__checkout-button, #checkout, [data-checkout-redirection="true"]'
        )
      : null;
    if (!target) return;

    capture('checkout_started', {
      trigger: target.tagName,
      href: target.getAttribute && target.getAttribute('href'),
      label: (target.textContent || '').trim().slice(0, 80)
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    if (form.getAttribute('action') && String(form.getAttribute('action')).indexOf('/search') !== -1) {
      var input = form.querySelector('input[name="q"]');
      capture('search_submitted', {
        search_terms: input ? input.value : '',
        source: 'form_submit'
      });
    }
  });

  bindNavigation();

  waitFor(function () {
    return window.theme && window.theme.pubsub;
  }, bindThemePubsub);
})();
